const THREE = require('three');

export default function (settings) {
  return new THREE.MeshPhongMaterial( settings )
  // return new THREE.MeshLambertMaterial( settings )
  // return new THREE.LineDashedMaterial( settings )
  // return new THREE.MeshToonMaterial( settings )
}
